import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ActivationJourneyService } from '../../onboarding-checklist/activation-journey.service';
import { EXAMPLE_PREVIEW_COPY } from './example-preview-copy';

@Component({
  selector: 'app-what-you-control',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './what-you-control.component.html',
  styleUrl: './what-you-control.component.css',
})
export class WhatYouControlComponent implements OnInit {
  readonly copy = EXAMPLE_PREVIEW_COPY;
  @Input() compact = false;
  @Input() trackShown = false;

  constructor(private activationJourney: ActivationJourneyService) {}

  ngOnInit(): void {
    if (this.trackShown) {
      this.activationJourney.trackEvent('control_awareness_shown', {
        source: 'standalone',
      });
    }
  }
}
